import React from 'react';
import PropTypes from 'prop-types';
import HelpButton from '../../clientHelpModal/clientHelpModal';
import {
    ActionCard,
    CardIconWrap,
    CardLabel,
    CardsGrid,
    HomeContent,
    HomeTitle,
    PageRoot,
} from '../styles';

function ClientHomeView({ pageTitle, cards, currentLanguage }) {
    return (
        <PageRoot>
            <HomeContent>
                <HelpButton view='VIEW_CLIENT_HOME' currentLanguage={currentLanguage} />

                <HomeTitle>{pageTitle}</HomeTitle>

                <CardsGrid>
                    {cards.map(({ id, title, url, Icon }) => (
                        <ActionCard key={id} href={url}>
                            <CardIconWrap>
                                <Icon />
                            </CardIconWrap>
                            <CardLabel>{title}</CardLabel>
                        </ActionCard>
                    ))}
                </CardsGrid>
            </HomeContent>
        </PageRoot>
    );
}

ClientHomeView.propTypes = {
    pageTitle: PropTypes.string.isRequired,
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            Icon: PropTypes.elementType.isRequired,
        })
    ).isRequired,
    currentLanguage: PropTypes.object.isRequired,
};

export default ClientHomeView;
